import axiosInstance from "../../../config/axios-config";

async function fetchUserData(url, setUserInfo, username, jwtToken) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    const data = await response.data;
    setUserInfo({
      id: username,
      name: data.name,
      department: data.department,
      collegeEmailId: data.collegeEmailId,
      profilePictureLink: data.profilePictureLink,
    });
  } catch (err) {
    console.error(err);
  }
}

async function fetchEditProfileData(url, setDetails, jwtToken) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    const data = await response.data;
    setDetails({
      personalEmail: !data.personalEmailId ? "" : data.personalEmailId,
      linkedin: !data.linkedInProfile ? "" : data.linkedInProfile,
      github: !data.githubProfile ? "" : data.githubProfile,
      twitter: !data.twitterProfile ? "" : data.twitterProfile,
      bio: !data.bio ? "" : data.bio,
    });
  } catch (err) {
    console.error(err);
  }
}

async function updateUserPassword(
  url,
  jwtToken,
  userPayload,
  errors,
  setErrors
) {
  let result = Object.values(errors).every((e) => e === "");
  var status = false;
  if (result) {
    await axiosInstance
      .post(url, userPayload, {
        headers: { Authorization: `Bearer ${jwtToken}` },
      })
      .then((response) => {
        const data = response.data;
        console.log(data);
        status = true;
      })
      .catch((err) => {
        console.error(err.response.status);
        const error = err.response.status;
        if (error === 304) {
          setErrors({
            oldPassword: "Incorrect password!",
            newPassword: "",
            confirmPassword: "",
            commonError: "",
          });
        }
      });
  }
  return status;
}

async function updateUserDetails(
  url,
  jwtToken,
  userPayload,
  errors,
  setDetailErrors
) {
  let result = Object.values(errors).every((e) => e === "");
  var status = false;
  if (result) {
    await axiosInstance
      .put(url, userPayload, {
        headers: { Authorization: `Bearer ${jwtToken}` },
      })
      .then((response) => {
        const data = response.data;
        console.log(data);
        status = true;
      })
      .catch((err) => {
        console.log(err);
        setDetailErrors({
          personalEmail: "",
          linkedin: "",
          github: "",
          twitter: "",
          bio: "",
          commonError: "Could not update profile!",
        });
      });
  }
  return status;
}

export {
  fetchUserData,
  fetchEditProfileData,
  updateUserPassword,
  updateUserDetails,
};
